// src/main/shell/symbolGrid/emitter.ts
// Minimal EventEmitter — the agent's SymbolTreeView extended Node's `events`
// EventEmitter, but that's a Node builtin (not available in the browser bundle
// without a polyfill). This is a tiny drop-in with the same `.on/.off/.emit/
// .removeAllListeners` surface the ported code uses. No dependency, no polyfill.

// Listeners are invoked with whatever args `emit` passes; ported call sites use
// concretely-typed handlers (e.g. (e: ViewChangedEvent) => void), so the param
// is `any` to stay assignable both ways without per-call casts.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Listener = (...args: any[]) => void;

export class EventEmitter {
  private _listeners = new Map<string, Set<Listener>>();

  on(event: string, listener: Listener): this {
    let set = this._listeners.get(event);
    if (!set) {
      set = new Set();
      this._listeners.set(event, set);
    }
    set.add(listener);
    return this;
  }

  off(event: string, listener: Listener): this {
    this._listeners.get(event)?.delete(listener);
    return this;
  }

  emit(event: string, ...args: unknown[]): boolean {
    const set = this._listeners.get(event);
    if (!set || set.size === 0) return false;
    // Iterate a copy so handlers can on/off during dispatch.
    for (const l of [...set]) l(...args);
    return true;
  }

  removeAllListeners(): this {
    this._listeners.clear();
    return this;
  }
}
